const utils = require('frontend-controller/lib/utils')

/*
    this is one variant of a static form.
    it contains static fields without any db-data and is used to select a timeRange without any server-requests.
 */

module.exports = {
    extends: [
        '/',
        'templates',
        'core',
        'form',
        'form',
    ],

    formMapping: {
        cols: [[{
            type: 'tag',
            tag: 'p',
            messageKey: 'employees.showSelectTimeRangeIntro'
        },{
            type: 'fieldGroup',
            source: 'resourceFields'
        }]]
    },

    config: {
        resourceConnected: false
    },

    model: {
        config: {
            fields: {
                monthStartTS: {
                    initDate: 'now',
                    initDateStartOf: 'month',
                    initDateModification: {
                        diff: {
                            months: -1,
                        },
                    },
                    airDatePicker: {
                        dateFormat: 'MMM. yyyy',
                        view: 'months', // days, months, years
                        minView: 'months',
                        // timeFormat: 'HH:mm',
                        // timepicker: true,
                        // minutesStep: 5
                    },
                    momentDateFormat: 'MMM YYYY',
                }
            }
        },

        fields: [
            {
                fieldCode: 'monthStartTS',
                config: {},
                atom: {
                    code: 'AIR_DATETIME',
                    dataType: 'datetime',
                    renderType: 'air-datetime-picker',
                },
                lang: {
                    'de-at': {
                        label: 'Zeitraum'
                    }
                },
            },
        ]
    },

    methods: {
        prepare(){
            const fieldConfig = this.model.config || {}
            for(const fieldCode in fieldConfig.fields || {}){
                utils.forEach(this.model.fields || [], (field, modelFieldIndex) => {
                    if(field.fieldCode === fieldCode){
                        utils.refMerge(field.config, fieldConfig.fields[fieldCode])

                        // hide options which should be available instead of disabling them.
                        if(field.config.disabled){
                            this.model.fields.splice(modelFieldIndex, 1)
                        }
                        return false
                    }
                })
            }
        },
    },

    hooks: {
        onDecision($element, options){
            options = options || {}
            const decisionOptions = options.decisionOptions || {}

            if(options.decisionType === 'decisionComponent' && decisionOptions.mode === 'select'){
                decisionOptions.monthStartTS = (((this.model.dirtyFields || {}).data || {}).attributes || {}).monthStartTS
                let initiatorFound = false
                this.locate('< base_modal_modal < *', initiator => {
                    initiatorFound = true
                    options.decisionTriggerComponent = this
                    initiator.trigger('onDecision', options)
                })

                if(!initiatorFound){
                    console.error('missing initiator')
                }
            }
        },
    },
}